import { CanActivateFn, Router } from '@angular/router';
import { Capacitor } from '@capacitor/core';
import { inject } from '@angular/core';
import { LoginSettingsFacade } from '@lyceo/homi/login/data-access';

export function websiteGuard(): CanActivateFn {
  return () => {
    const router: Router = inject(Router);
    const loginSettingsFacade: LoginSettingsFacade =
      inject(LoginSettingsFacade);

    if (Capacitor.getPlatform() !== 'web') {
      const websiteSet: boolean = loginSettingsFacade.websiteSet();
      if (!websiteSet) {
        return router.createUrlTree(['/website']);
      }
    }

    return true;
  };
}
